import Register from "./register-component";

export default Register